import './App.scss';
import { useState } from 'react';
import { PopupModal } from "react-calendly";
import MainRouter from './MainRouter';
import { CalendlyContext } from './hooks/useCalendly';

function App () {
  const [calendlyIsOpened, setCalendlyIsOpened] = useState(false);

  const calendlyProps = {
    url: process.env.REACT_APP_CALENDLY ?? '',
    pageSettings: {
      backgroundColor: 'ffffff',
      hideEventTypeDetails: false,
      hideLandingPageDetails: false,
      primaryColor: '00b2ca',
      textColor: '4d5055'
    },
    onModalClose: () => setCalendlyIsOpened(false),
    open: calendlyIsOpened,
    rootElement: document.getElementById("root") ?? document.body,
  }

  return (
    <CalendlyContext.Provider value={{ setCalendlyIsOpened }}>
      <PopupModal {...calendlyProps} />
      <MainRouter />
    </CalendlyContext.Provider>
  );
}

export default App;
